import { States } from 'safe'
import {
  CLEAN_PURCHASE_ORDERS,
  PurchaseOrdersTypes,
  SET_PURCHASE_ORDERS,
} from '../actions/actionTypes'

export const initialState: States.PurchaseOrders = {
  purchaseOrders: [],
  numberOfPages: 0,
}

export default (
  state = initialState,
  action: PurchaseOrdersTypes
): States.PurchaseOrders => {
  switch (action.type) {
    case SET_PURCHASE_ORDERS:
      return {
        purchaseOrders: action.payload.purchaseOrders,
        numberOfPages: action.payload.numberOfPages,
      }
    case CLEAN_PURCHASE_ORDERS:
      return {
        purchaseOrders: [],
        numberOfPages: 0,
      }
    default:
      return state
  }
}
